module.exports = __webpack_public_path__ + "img/42.9615bb0f.jpg";